<template>
  <v-dialog v-model="viewNbnTroubleTicket" width="600" persistent>
    <v-card class="pb-4">
      <v-card-title class="primary">
        <span class="white--text"
        >Trouble Ticket - {{ ticketData.id }}</span
        >
      </v-card-title>
      <v-card-text class="subtitle-1 pb-0">
        <v-row>
          <v-col>
            <b>Trouble Ticket Id: </b> {{ ticketData.id }}<br />
            <b>External Id: </b> {{ ticketData.externalId }}<br />
            <b>Status: </b> {{ ticketData.status }}<br />
            <b>Ticket Type: </b> {{ ticketData.ticketType }}<br />
            <b>Category: </b> {{ ticketData.category }}<br />
            <div v-if="ticketData.subCategory"> <b>Sub-Category </b> {{ ticketData.subCategory }}<br /></div>
            <b>Severity: </b> {{ ticketData.severity }}<br />
            <b>Creation Date: </b> {{ ticketData.creationDate }}<br />
            <b>Description: </b> {{ ticketData.description }}<br />
            <div v-if="ticketData.fnnServiceIdentifier"> <b>Fnn: </b> {{ ticketData.fnnServiceIdentifier }}<br /></div>
            <div v-if="ticketData.ullServiceIdentifier"> <b>Ull: </b> {{ ticketData.ullServiceIdentifier }}<br /></div>
            <div v-if="ticketData.relatedPlace"> <b>Location Id: </b> {{ ticketData.relatedPlace.id }}<br /></div>
            <div v-if="ticketData.relatedEntityRef"> <b>Order Id: </b> {{ ticketData.relatedEntityRef.id }}<br /></div>
            <div v-if="ticketData.expectedServiceabilityClass"> <b>Expected service class: </b> {{ ticketData.expectedServiceabilityClass }}<br /></div>
            <div v-if="ticketData.serviceabilityClass"> <b>Returned Service class: </b> {{ ticketData.serviceabilityClass }}<br /></div>
            <div v-if="ticketData.physicalAddress"> <b>State: </b> {{ ticketData.physicalAddress.stateTerritoryCode }}<br /></div>
            <div v-if="ticketData.physicalAddress"> <b>Suburb: </b> {{ ticketData.physicalAddress.localityName }}<br /></div>
            <div v-if="ticketData.physicalAddress"> <b>Street Number: </b> {{ ticketData.physicalAddress.roadNumber1 }}<br /></div>
            <div v-if="ticketData.physicalAddress"> <b>Street Name: </b> {{ ticketData.physicalAddress.roadName }}<br /></div>
            <div v-if="ticketData.physicalAddress"> <b>Street Type: </b> {{ ticketData.physicalAddress.roadTypeCode }}<br /></div>
            <div v-if="ticketData.relatedProduct"> <b>Product Id: </b> {{ ticketData.relatedProduct.id }}<br /></div>
            <div v-if="ticketData.relatedService"> <b>Service Id: </b> {{ ticketData.relatedService[0].id }}<br /></div>
            <div v-if="ticketData.endUserEngagementType"> <b>Fault Location: </b> {{ ticketData.endUserEngagementType == "Appointment"?"Inside End User's Premises":"Outside End User's Premises" }}<br /></div>
            <div v-if="ticketData.relatedAppointment"> <b>Appointment Id: </b> {{ ticketData.relatedAppointment.id }}<br /></div>
            <div v-if="ticketData.relatedContact"> <b>Contact Name: </b> {{ ticketData.relatedContact.contactName }}<br /></div>
            <div v-if="ticketData.relatedContact"> <b>Contact Number: </b> {{ ticketData.relatedContact.phoneNumber }}<br /></div>
            <div v-if="ticketData.relatedTestResults"><b>Test Result Id:</b></div>
            <div v-if="ticketData.relatedTestResults"
                 v-for="(item, index) in ticketData.relatedTestResults"
                 :key="index"> {{ item.id }}<br /></div>
            <div v-if="ticketData.checklist"><b>Check List:</b></div>
            <div v-if="ticketData.checklist">
              <div v-for="(item, index) in (ticketData.checklist.content).split('\\n')" :key="index">
                {{ item }}<br />
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col >
          <ValidationProvider
            name="Add new Appointment Id"
            :rules="'required'"
            v-slot="{ errors }"
          >
            <v-text-field
              v-model="newAppointment"
              label="Add New Appointment Id"
              placeholder=" "
              outlined
              dense
            ></v-text-field>
          </ValidationProvider>
        </v-col></v-row>
        <v-row>
          <v-col>
          <span class="font-weight-bold">Trouble Ticket - Comments</span>
          <div
            v-for="(item, index) in ticketData.note"
            :key="index"
            class="mt-4 pt-4 row-border"
          >
            <b>Author: </b> {{ item.author }}<br />
            <b>Date: </b> {{ item.date }}<br />
            <b>Comment: </b> {{ item.text }}<br />
          </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
              <v-textarea v-model="newComment" label="New Comment" variant="outlined"></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>


      <v-divider></v-divider>

      <v-card-actions class="mt-4">
        <v-spacer></v-spacer>
        <v-btn @click="onTriggerSubmit" class="mr-4" :disabled="newComment == ''">Submit Comment</v-btn>
        <v-btn @click="onTriggerAddAppointment" class="mr-4" :disabled="newAppointment == ''">Add New Appointment</v-btn>
        <v-btn @click="$emit('close-trouble-ticket')" class="mr-4">Close</v-btn>
      </v-card-actions>
    </v-card>
    <confirm-action
      :dialog="submitDialog"
      :text="submitDialogText"
      :proceedText="`Yes`"
      :cancelText="`No`"
      @onBtnClick="onSubmitConfirm"
    ></confirm-action>

    <confirm-action
      :dialog="addAppointmentDialog"
      :text="submitAppointmentDialogText"
      :proceedText="`Yes`"
      :cancelText="`No`"
      @onBtnClick="onSubmitAppointmentConfirm"
    ></confirm-action>
  </v-dialog>
</template>

<script>
export default {
  name: "view-nbn-trouble-ticket",
  props: {
    viewNbnTroubleTicket: {
      type: Boolean,
      required: true,
    },
    ticketData: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    submitDialog: false,
    addAppointmentDialog: false,
    submitDialogText: "Are you sure you want to submit this comment?",
    submitAppointmentDialogText: "Are you sure you want to add this new appointment?",
    newComment: "",
    newAppointment: ""
  }),
  methods: {
    onTriggerSubmit() {
      let vm = this;
      vm.submitDialog = true;
    },
    onTriggerAddAppointment() {
      let vm = this;
      vm.addAppointmentDialog = true;
    },
    onSubmitConfirm(args) {
      let vm = this;

      if (args) {
        let payload = {
          "Note":vm.newComment,
          "TicketId":vm.ticketData.id
        };

        vm.addTicketNote(payload).then(() => {
          vm.submitDialog = false;
          vm.newComment = '';
          vm.newAppointment = '';
          vm.$emit('close-trouble-ticket')
        });
      } else vm.submitDialog = false;

    },
    onSubmitAppointmentConfirm(args) {
      let vm = this;

      if (args) {
        let payload = {
          "TicketId":vm.ticketData.id,
          "AppointmentId":vm.newAppointment
        };

        vm.amendTroubleTicket(payload).then(() => {
          vm.addAppointmentDialog = false;
          vm.newAppointment = '';
          vm.$emit('close-trouble-ticket')
        });
      } else vm.addAppointmentDialog = false;
    }
  }
}
</script>

<style scoped>
.border {
  border-color: #2cd375 !important;
}
</style>
